import {React} from 'react';


export function CalculationDescriptionModal(){
    return (
        <></>
    )
}